import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { useActionSheet } from '@expo/react-native-action-sheet';
import {
  airOptionMap,
  hotelOptionMap,
  carOptionMap,
  railOptionMap,
} from '../../utils/search.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';

import { Ionicons } from '@expo/vector-icons';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { Color, CommonStyles } from '../../styles';

const SearchSubTypePickerRebook = (props) => {
  const { rowBtnStyle, dominantSearchType, subSearchType, onSelection } = props;
  const { showActionSheetWithOptions } = useActionSheet();
  const { t } = useTranslation(i18nNS.searchWidget);
  const { tKey } = useComponentTKey('SearchSubTypePicker');
  const cancelButtonIndex = 7;
  const componentMap = {
    air: airOptionMap,
    hotel: hotelOptionMap,
    car: carOptionMap,
    rail: railOptionMap,
  };
  const translatedSubTypeMap = Object.keys(componentMap[dominantSearchType]).reduce(
    (r, key) => ((r[key] = t(tKey(componentMap[dominantSearchType][key]))), r),
    {}
  );
  const translatedOptions = Object.values(translatedSubTypeMap);
  return (
    <TouchableOpacity style={rowBtnStyle}>
      <View style={styles.textContainer}>
        <Icon size={28} name="mark" style={CommonStyles.mr3} color={Color.text.low} />
        <BaseText style={CommonStyles.h2}>{translatedSubTypeMap[subSearchType]}</BaseText>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  textContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default memo(SearchSubTypePickerRebook);
